var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AngleRight } from '@mehilainen/mds-icons';
import { radius, shadow } from '@mehilainen/mds-tokens';
import { Gray250, Gray700, Gray800, Gray900, Info500, Primary500, White, } from '@mehilainen/mds-tokens/colors';
import { spacing } from '@mehilainen/mds-tokens/spacing';
import { baseTypography } from '@mehilainen/mds-tokens/typography';
import { Box, Stack, styled } from '@mui/material';
const Container = styled(Box)({
    backgroundColor: White,
    borderRadius: radius[200].px,
    overflow: 'hidden',
    border: `1px solid ${Gray250}`,
    paddingLeft: spacing[500].px,
    paddingRight: spacing[500].px,
    '&:hover': {
        boxShadow: shadow[100],
    },
    '&:focus-visible': {
        borderColor: Info500,
    },
});
const IconContainer = styled('span')({
    color: Primary500,
    fontSize: baseTypography.size.icon[400].px,
    display: 'flex',
    paddingRight: spacing[400].px,
});
const TextContainer = styled(Stack)({
    gap: spacing[300].px,
    textAlign: 'left',
});
const TitleContainer = styled(Stack)({
    gap: spacing[100].px,
});
const Title = styled(Stack)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing[300].px,
    color: Gray900,
    fontSize: baseTypography.size[400].rem,
    fontWeight: baseTypography.weight.Medium,
    lineHeight: baseTypography.height.Medium,
});
const Label = styled(Title)({
    color: Primary500,
    fontSize: baseTypography.size[300].rem,
    fontWeight: baseTypography.weight.Regular,
});
const Description = styled(Title)({
    fontSize: baseTypography.size[300].rem,
    fontWeight: baseTypography.weight.Regular,
    lineHeight: baseTypography.height.Medium,
    color: Gray800,
});
const Detailed = styled(Description)({
    fontSize: baseTypography.size[300].rem,
    color: Gray700,
});
const ContentContainer = styled(Stack)({
    flex: 1,
    overflowWrap: 'anywhere',
    paddingTop: spacing[600].px,
    paddingBottom: spacing[600].px,
    gap: spacing[400].px,
    alignItems: 'flex-start',
});
const RowContainer = styled(Stack)({
    flexDirection: 'row',
    alignItems: 'center',
});
/**
 * Event component
 *
 * Shows various health-related tasks
 * @param additionalComponent - Additional component situated below titles
 * @param description - Description text
 * @param detailed - Detailed text
 * @param startIcon - Icon component
 * @param sx - Custom styles using MUI's sx prop
 * @param title - Title text
 * @param topLabel - Top label text
 * @returns Event component
 */
export const Event = (props) => {
    const { sx, startIcon, title, description, detailed, additionalComponent, topLabel, component = 'button' } = props, additionalProps = __rest(props, ["sx", "startIcon", "title", "description", "detailed", "additionalComponent", "topLabel", "component"]);
    return (_jsx(Container, Object.assign({ sx: sx, component: component }, additionalProps, { children: _jsxs(RowContainer, { children: [startIcon && (_jsx(IconContainer, Object.assign({ "aria-hidden": "true" }, { children: startIcon }))), _jsxs(ContentContainer, { children: [_jsxs(TextContainer, { children: [_jsxs(TitleContainer, { children: [topLabel && _jsx(Label, { children: topLabel }), _jsx(Title, { children: title }), description && _jsx(Description, { children: description })] }), detailed && _jsx(Detailed, { children: detailed })] }), additionalComponent] }), _jsx(AngleRight, { "aria-hidden": "true", sx: {
                        fontSize: baseTypography.size.icon[500].px,
                        color: Gray700,
                        paddingLeft: spacing[500].px,
                    } })] }) })));
};
